import React from 'react';
import { useHistory } from 'react-router-dom';

import { Card, LogButton } from './common';

import rightArrow from '../../images/common/arrow-right-black.svg';
import GlassIcon from '../../images/health-content/glass-icon.svg';

function WaterCard({ waterCard }) {
  const history = useHistory();
  return (
    <Card
      onClick={() => history.push('/water-details')}
      className="w-half p-15 mt-2 health-card flex flex-col justify-between"
    >
      <div>
        <div className="flex justify-between w-full">
          <img src={GlassIcon} alt="glass-icon" />
          <img src={rightArrow} alt="right-arrow" className="w-6px" />
        </div>
        <h4 className="text-caption-l font-semibold mt-10">Water</h4>
        <h1 className="text-title-l font-bold mt-1">
          {waterCard.current}
          <span className="text-button-l font-bold">ltr</span>
        </h1>
        <p className="text-sub text-caption-s">Recommended: &nbsp;</p>
        <p
          className=" font-semibold text-caption-s "
          style={{
            color: '#5A68E7',
          }}
        >
          {waterCard.goal} litres
        </p>
      </div>
      <LogButton
        buttonText="Log"
        onClick={(e) => {
          history.push('/water-details');
        }}
      />
    </Card>
  );
}

export default WaterCard;
